module.exports = __webpack_public_path__ + "img/fifa.2b99036a.webp";